module.exports = __webpack_public_path__ + "static/hotels-6ce57a5ca09f62d49ff3d64d1c2b2ceb.png";